import { render, staticRenderFns } from "./Filmanalysis.vue?vue&type=template&id=ad856cb8&scoped=true"
import script from "./Filmanalysis.vue?vue&type=script&lang=js"
export * from "./Filmanalysis.vue?vue&type=script&lang=js"
import style0 from "./Filmanalysis.vue?vue&type=style&index=0&id=ad856cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad856cb8",
  null
  
)

export default component.exports